import { setError } from '../features/user/UserSlice';
import { store } from './store';

export const showError = error =>
{
    store.dispatch(setError(error));
}